import React, { useEffect, useState } from "react";
export default function Tab(props) {
    var _a;
    const [animationPlaying, setAnimationPlaying] = useState(false);
    useEffect(() => {
        const timeout = setTimeout(() => setAnimationPlaying(false), 1000);
        return () => clearTimeout(timeout);
    }, [animationPlaying]);
    return (React.createElement("button", { "data-name": props.name, className: props.isOpen
            ? animationPlaying
                ? "tab tab-open tab-active"
                : "tab tab-open"
            : "tab", onClick: () => {
            setAnimationPlaying(true);
            props.onOpen();
        } }, (_a = props.labelName) !== null && _a !== void 0 ? _a : props.name));
}
